import './inventory.view.scss'
import templateUrl from './inventory.view.html'

/**
 * Inventory detail Report route
 *
 * @namespace routes.ReportInventoryView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.inventories.view',
  label: 'REPORT.INVENTORIES.VIEW.TITLE',
  component: 'tmrReportInventoryView',
  accessControl: ['Resource.view', 'Resource.Inventory.view'],
  abstract: false,
  params: {
    inventoryBreadcrumb: 'app.report.inventories.list',
  },
}

/**
 * Component for {@link routes.tmrReportInventoryView Inventories Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportInventoryView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportInventoryViewController',
  bindings: {
    resource: '<',
  },
}

/**
 * Controller of component {@link tmrReportInventoryView}.
 *
 * @type {ngController}
 */
export class tmrReportInventoryViewController {
  static ngType = 'controller'

  constructor($mdDialog, $scope, $stateParams) {
    'ngInject'
    Object.assign(this, { $mdDialog, $scope, $stateParams })
  }

  $onInit() {
    this.inventoryBreadcrumb = this.$stateParams.inventoryBreadcrumb

    if (this.resource.inventoryCounters) {
      this.expectedDetected =
        this.resource.inventoryCounters.detected -
        this.resource.inventoryCounters.unexpected
    }
    if (this.expectedDetected < 0) this.expectedDetected = 0
    this.details = []
    if (this.resource.inventoryZones.length)
      this.details.push({
        label: 'REPORT.INVENTORIES.VIEW.ZONES',
        value: this.resource.inventoryZones
          .map(zone => zone.$getLabel())
          .join(', '),
      })
    if (this.resource.ignoredZones.length)
      this.details.push({
        label: 'REPORT.INVENTORIES.VIEW.IGNOREDZONES',
        value: this.resource.ignoredZones
          .map(zone => zone.$getLabel())
          .join(', '),
      })
    if (this.resource.toCheckZone.id)
      this.details.push({
        label: 'REPORT.INVENTORIES.VIEW.TOCHECKZONE',
        value: this.resource.toCheckZone.$getLabel(),
      })
    if (this.resource.lostZone.id)
      this.details.push({
        label: 'REPORT.INVENTORIES.VIEW.LOSTZONE',
        value: this.resource.lostZone.$getLabel(),
      })
    if (this.resource.creationDate)
      this.details.push({
        label: 'REPORT.INVENTORIES.VIEW.CREATIONDATE',
        value: this.resource.creationDate,
        filter: 'date',
        filterArgs: 'medium',
      })
    if (this.resource.closingDate)
      this.details.push({
        label: 'REPORT.INVENTORIES.VIEW.CLOSINGDATE',
        value: this.resource.closingDate,
        filter: 'date',
        filterArgs: 'medium',
      })
    this.filters = []
    if (
      this.resource.productGroup &&
      this.resource.productGroup.queryParameter
    ) {
      const queryParam = JSON.parse(this.resource.productGroup.queryParameter)
      Object.entries(queryParam).forEach(([filterName, values]) => {
        if (values && values.length > 0) {
          this.filters.push({
            label: filterName,
            value: values.join(', '),
          })
        }
      })
    }
  }

  expectedDetails(targetEvent) {
    this.$mdDialog.show(
      this.$mdDialog.tmrExpectedItems({
        targetEvent,
        locals: { inventory: this.resource },
      })
    )
  }

  missingDetails(targetEvent) {
    this.$mdDialog.show(
      this.$mdDialog.tmrMissingItems({
        targetEvent,
        locals: { inventory: this.resource },
      })
    )
  }

  unexpectedDetails(targetEvent) {
    this.$mdDialog.show(
      this.$mdDialog.tmrUnexpectedItems({
        targetEvent,
        locals: { inventory: this.resource },
      })
    )
  }
}
